export enum AuroraCirculationPumpMode {
  OFF = 'off',
  AUTO = 'auto',
  MAX = 'max',
  MIN = 'min'
}

export default AuroraCirculationPumpMode
